module.exports = __webpack_public_path__ + "img/kwaternion50.ae627dcf.png";